import React from "react";

import VibeLogo from "@assets/vibe-logo.svg";
import { LearnMoreTooltip } from "@features/sales-v3/top-level-filters/components/learn-more-tooltip";
import { ConnectionType } from "@north-beam/nb-client-side";
import { ConnectionCard } from "@pages/settings/connection-card";
import {
  type LoginComponentChildrenProps,
  type LoginComponentProps,
} from "@pages/settings/connection-status-manager";
import { PrimaryButton } from "@shared/buttons";

const type = ConnectionType.integration_vibe;

export function VibeConnectionCard() {
  return (
    <ConnectionCard
      type={type}
      connectionTypeName="Vibe"
      connectionCallToAction="Integrate your Vibe account"
      logoUrl={VibeLogo}
      logoAltText="Vibe Logo"
      successfulConnectionExtraText={() => null}
      supportMultipleAccounts="subAccounts"
    >
      {({
        upsertConnection,
        isLoading,
        accounts,
      }: LoginComponentChildrenProps) => (
        <VibeLoginComponent
          upsertConnection={upsertConnection}
          isLoading={isLoading}
          accounts={accounts}
        />
      )}
    </ConnectionCard>
  );
}

function VibeLoginComponent({
  upsertConnection,
  isLoading,
}: Omit<LoginComponentProps, "setStatus" | "integrationDetails">) {
  const [apiKey, setApiKey] = React.useState("");

  const onConnectClicked = React.useCallback(async () => {
    await upsertConnection({
      api_key: apiKey.trim(),
    });
  }, [apiKey, upsertConnection]);

  return (
    <div className="mb-3">
      <div className="flex flex-col gap-y-5">
        <div>
          <div>
            API Key
            <LearnMoreTooltip
              title="Vibe API Key"
              content="Provide your API Key according to Vibe's instructions"
              link="https://help.vibe.co/en/articles/8943325-vibe-api-reporting"
            />
          </div>
          <input
            disabled={isLoading}
            type="text"
            className="max-w-xl form-control"
            value={apiKey}
            placeholder="API Key..."
            id="vibeApiKey"
            onChange={(event) => setApiKey(event.target.value)}
          />
        </div>
        <div>
          <PrimaryButton
            loading={isLoading}
            disabled={!apiKey.trim()}
            onClick={onConnectClicked}
          >
            {isLoading ? "Please Wait..." : "CONNECT"}
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
}
